import React, { Component } from 'react';
import MenuLayout from './pages/MenuLayout';
import { Redirect, Route, Switch, HashRouter as Router } from 'react-router-dom';
import './App.css';
import 'antd/dist/antd.css';
import 'antd-button-color/dist/css/style.css';
import { connect } from 'react-redux'


class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            errorToasterVisible: false,
            errorToasterTitle: "",
            errorToasterMessage: ""
        }
    }

    componentDidMount() {
	}

    render() {
        const {profile} = this.props
        return (
            <Router>
                <Switch>
                    <Route path="/menu" render={() => <MenuLayout/>} />
                    {/* <Route path="/" render={() => <MenuLayout/> } /> */}
                    <Route render={() => <Redirect to="/menu" />} />
                </Switch>
            </Router>
        )
    }
}

const mapStateToProps = state => ({
	profile: state.profile
})


export default connect(mapStateToProps)(App);